import React from 'react'
import Typography from 'APP/Converse/Typography'
import styled from 'styled-components/native'

const StyledTooltipContainer = styled.View`
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 0.25}px;
`

interface InfotipProps {
  error?: string
  infotip?: string
  isFocused?: boolean
  isPersistent?: boolean
  id?: string
}

const Infotip = ({ error, infotip, isFocused, isPersistent, id }: InfotipProps) => {
  const showError = Boolean(error)
  const showInfotip = Boolean(infotip) && (isFocused || isPersistent)

  // Don't render anything if no content will be shown
  if (!showError && !showInfotip) {
    return null
  }

  return (
    <StyledTooltipContainer>
      {showError && (
        <Typography
          variant="bodySmallBold"
          color="error"
          accessibilityRole="alert"
          aria-live="assertive"
          id={id}
        >
          {error}
        </Typography>
      )}
      {showInfotip && !showError && (
        <Typography variant="bodySmallBold" id={id}>
          {infotip}
        </Typography>
      )}
    </StyledTooltipContainer>
  )
}

export default Infotip
